import "../CSS/formAgregarUsuario.css";
import IncrementadorNum from "./IncrementadorNum";
import React, { useRef, useEffect, useState, Fragment } from "react";
import NavBar from "./NavBar";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import ItemUsuario from "./ItemUsuario";
import Box from "@mui/material/Box";

import TextField from "@mui/material/TextField";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import ContactMailRoundedIcon from "@mui/icons-material/ContactMailRounded";
import PasswordRoundedIcon from "@mui/icons-material/PasswordRounded";
import { db } from "../FirebaseConfig/firebase";
import { useNavigate, useParams } from "react-router-dom";
import { collection, addDoc, getDoc, setDoc, doc } from "firebase/firestore";

const MySwal = withReactContent(Swal);
function FormEditarUsuario() {
  const { id } = useParams();

  const [cip, setCip] = React.useState("");
  const [estado, setEstado] = React.useState("");
  const [nivel, setNivel] = React.useState("");
  const [nombre, setNombre] = React.useState("");
  const [apellidos, setApellidos] = React.useState("");
  const [especialidad, setEspecialidad] = React.useState("");
  const [dni, setDni] = React.useState("");

  const navigate = useNavigate();
  const comunicadosList = collection(db, "USUARIOS");

  const handleChangeEst = (event) => {
    setEstado(event.target.value);
  };
  const handleChangeNiv = (event) => {
    setNivel(event.target.value);
  };
  const validarFormulario = (e) => {
    console.log(dni);
    if (
      cip == "" ||
      estado == "" ||
      nivel == "" ||
      nombre == "" ||
      dni == "" ||
      apellidos == "" ||
      especialidad == ""
    ) {
      MySwal.fire("", "Llenar todos los campos", "error");
    } else {
      update(e);
    }
  };
  //Funcion para mostrar detalles del usuario
  const getUserById = async (id) => {
    console.log(" EL ID ES" + id);
    const user = await getDoc(doc(db, "USUARIOS", id));
    if (user) {
      setNombre(user.data().nombre);
      setDni(user.data().dni);
      setCip(user.data().cip);
      setNivel(user.data().nivel);
      setApellidos(user.data().apellidos);
      setEspecialidad(user.data().especialidad);
      setEstado(user.data().estado);

      console.log(user.data());
    } else {
      console.log("no existe");
    }
  };
  //funcion para editar usuario
  const update = async (e) => {
    MySwal.fire({
      title: "Editar usuario? ",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Editar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        e.preventDefault();
        console.log(id);
        const cupon = doc(db, "USUARIOS", id);
        const data = {
          nombre: nombre,
          apellidos: apellidos,
          dni: dni,
          nivel: nivel,
          estado: estado,
          cip: cip,
          especialidad: especialidad,
        };
        await setDoc(cupon, data);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Usuario editado",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/panelAdmin/usuarios");
      }
    });
  };
  //cerrar editar usuario
  const cerrar = () => {
    navigate("../panelAdmin/Usuarios");
  };
  useEffect(() => {
    getUserById(id);
  }, []);
  return (
    <Fragment>
      <NavBar
        titulo="Editar Usuario"
        imagen="cerrar"
        logoTitulo="usuarios"
        cerrar={cerrar}
      ></NavBar>
      <div className="fau-agregarUsuarios">
        <div className="fau-card">
          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PersonRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Ingrese Nombre"
                  value={nombre}
                  variant="standard"
                  onChange={(e) => setNombre(e.target.value)}
                />
              </Box>
            </Box>
          </div>
          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PersonRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Ingrese Apellidos"
                  value={apellidos}
                  variant="standard"
                  onChange={(e) => setApellidos(e.target.value)}
                />
              </Box>
            </Box>
          </div>
          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PasswordRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Ingrese DNI"
                  variant="standard"
                  type="number"
                  value={dni}
                  onChange={(e) => setDni(e.target.value)}
                />
              </Box>
            </Box>
          </div>
          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <ContactMailRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Ingrese Codigo CIP"
                  variant="standard"
                  type="number"
                  value={cip}
                  onChange={(e) => setCip(e.target.value)}
                />
              </Box>
            </Box>
          </div>

          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PersonRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Ingrese Especialidad"
                  value={especialidad}
                  variant="standard"
                  onChange={(e) => setEspecialidad(e.target.value)}
                />
              </Box>
            </Box>
          </div>

          <div className="fau-formNumber">
            <Box sx={{ width: 300 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Nivel de usuario
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={nivel}
                  label="Nivel de usuario"
                  onChange={handleChangeNiv}
                >
                  <MenuItem value={"admin"}>Administrador</MenuItem>
                  <MenuItem value={"ingeniero"}>Ingeniero</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
          <div className="fau-formNumber">
            <Box sx={{ width: 300 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={estado}
                  label="Estado"
                  onChange={handleChangeEst}
                >
                  <MenuItem value={"HABILITADO"}>HABILITADO</MenuItem>
                  <MenuItem value={"NO HABILITADO"}>NO HABILITADO</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
          <div className="fau-formNumber">
            <div className="fau-addUser">
              <input
                type="submit"
                value="Editar usuario"
                className="fau-btnAgregarComunicado"
                onClick={validarFormulario}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default FormEditarUsuario;
